import React from 'react'
import { CommonCalendarButtonUi } from 'common/components/entities/Calendar/calendar-step/ui/common-calendar-button-ui'
import { PaidCalendarPaymentButtonProps } from 'common/types/entities/booking-paid-calendar-interface'
import FieldErrors from 'publisher/components/FieldErrors'
import useGocardlessPaymentHandler from 'publisher/hooks/payment/useGocardlessPaymentHandler'
import useManagement, {
  selectors as managementSelectors,
} from 'publisher/hooks/useManagement'

export const PaidCalendarGocardlessPaymentButton = ({
  entity,
  commonStyles,
}: PaidCalendarPaymentButtonProps) => {
  const { isLoading, handleSubmit, errors } =
    useGocardlessPaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <CommonCalendarButtonUi
        backgroundColor={entity.selectedSlotBackgroundColor}
        onClick={handleSubmit}
        disabled={isLoading || isPreview}
        {...commonStyles}
      >
        {entity.formButtonText}
      </CommonCalendarButtonUi>
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
